const ns = "CREDENTIAL_CHECKIN_SEARCH";
export const RECEIVE = `${ns}_RECEIVE`;
export const REQUEST = `${ns}_REQUEST`;
export const UPDATE_SEARCH_TERM = `${ns}_UPDATE_SEARCH_TERM`;
